import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, Input, ViewChild, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { LocalService, ManagerService, ProfileService } from 'src/app/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import dataJson from './quizPayload.json';
const data: any = dataJson;
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { QuizChallengeService } from 'src/app/core/services/quiz-challenge.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CONSTANTS } from 'src/app/config';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-quiz-challenge',
  templateUrl: './quiz-challenge.component.html',
  styleUrls: ['./quiz-challenge.component.scss']
})
export class QuizChallengeComponent implements OnInit {
  public quizForm!: FormGroup;
  public quizBasicInfoForm!: FormGroup;
  showQuizSetupForm: boolean = false;
  beGeoIdsValidationSuccess: boolean = true;
  allUsers: any[] = [];
  userProfile: any = null;
  @Input() challengeList: any;
  @Input() quizData: any = '';
  @Output() submitStatusEvent = new EventEmitter<boolean>();
  typeId: any;
  typeName: any;
  todayDate = new Date();
  begeoIdsValues: any[] = [];
  @ViewChild('quizFileInput') quizFileInput!: any;
  selectedFileName: any = '';
  selectedFile: any;
  bannerImagName = '';
  totalCompanyCreditsAvailable: any;
  fiscalOptionsList: any = [];
  isActiveEdit: boolean = false;
  deleteQuestionModalOpen: boolean = false;
  questionIndexToDelete: number = -1;
  selectedLanguage!: string;
  filteredOptions: Observable<any>[] = [];
  docTypeList: any = [];
  showDupsError: boolean = false;
  budgetSourceList = ['CONTRA', 'OPEX'];
  fiscalYearList: any = [];
  fiscalQuarterList: any = [];
  readonlyFlag: boolean = false;
  answerTypeOptions = [
    { id: 'SINGLE_ANSWER', name: 'Radio Button (Single choice)' },
    { id: 'MORE_THAN_ONE_ANSWER', name: 'Checkbox (Multiple choice)' },
    { id: 'TEXT', name: 'Free Style Text' }
  ];
  previewExistingBannerFlag: boolean = false;
  exsitingBannerImage: any = '';
  uploadExsitingBanner: boolean = false;
  uploadInProgress: boolean = false;
  imageCropperModalOpen = false;
  cropperEvent: any = null;
  cropperCroppedImage: any = '';
  bannerPreviewModalOpen = false;
  bannerPreviewSrc: any = '';
  croppedPreviewSrc: string = '';
  downloadExcelModalOpen = false;
  downloadExcelType = '';
  constructor(@Inject(DOCUMENT) private document: Document,
    private fb: FormBuilder,
    private quizfb: FormBuilder,
    private profileService: ProfileService,
    private managerService: ManagerService,
    private quizService: QuizChallengeService,
    private popupMessageService: PopupMessageService) {
  }

  addquestionGroup(): FormGroup {


    return this.fb.group({
      question: ['', [Validators.required]],
      answerType: ['', [Validators.required]],
      correctAnswerExplanation: ['', Validators.required],
      addNewOption: this.fb.array([this.newOptionGroup()]),
      accordianState: [true],
      addSingleQuestion: [false],
      answerValidation: [false]
    })
  }
  //  on click on add new question btn
  addNewQuestion() {
    this.questionArray.controls.forEach((val: any) => {
      val.controls.accordianState.setValue(false);
      val.controls.addSingleQuestion.setValue(true);
    });
    this.questionArray.push(this.addquestionGroup());
  }
  //  On click on add new option btn call the function 
  addNewOption(index: number): any {
    this.questionArray['controls'].forEach((element: any) => {

      element['controls'].addNewOption.controls.forEach((val: any) => {
        //val.controls.questionNum.value=val.controls.questionNum.value+1;

      })
    });

    (<FormArray>(
      (<FormGroup>this.questionArray.controls[index]).controls.addNewOption
    )).push(this.newOptionGroup());

  }

  get questionArray(): FormArray {
    return <FormArray>this.quizForm.get("NewQuestion")!;
  }
  newOptionGroup(): FormGroup {
    return this.fb.group({
      possibleAnswer: ['', Validators.required],
      correctAnser: [false],
      //questionNum:[1]
    })
  }
  openAccordian(i: number) {
    this.questionArray.controls.forEach((elmt: any, index: number) => {
      if (this.quizData != undefined) {
        elmt.controls.accordianState.setValue(i == index);
      } else {
        elmt.controls.accordianState.setValue(i == index || index == this.questionArray.controls.length - 1);
      }
    });
  }

  closeAccordian(i: number) {
    this.questionArray.controls.forEach((elmt: any, index: number) => {
      if (i == index) {
        elmt.controls.accordianState.setValue(false);
      }
    });
  }

  onQuestionPanelToggle(i: number, isOpen: boolean): void {
    if (isOpen) {
      this.openAccordian(i);
    } else {
      this.closeAccordian(i);
    }
  }

  removeQuestion(index: number): void {
    this.questionIndexToDelete = index;
    this.deleteQuestionModalOpen = true;
  }

  confirmDeleteQuestion(): void {
    this.questionArray.removeAt(this.questionIndexToDelete);
    this.deleteQuestionModalOpen = false;
    this.questionIndexToDelete = -1;
  }

  deleteOption(index: number, idx: number): void {
    (<FormArray>(<FormGroup>this.questionArray.controls[index]).controls.addNewOption).removeAt(idx);
  }
  intialiseQuizChallenge() {
    this.quizForm = this.fb.group(
      {
        welcomeMessage: ['', Validators.required],
        exitMessage: ['', Validators.required],
        failMessage: ['', Validators.required],
        bannerImg: [''],
        quizTitle: ['', Validators.required],

        answerOptionsOrderRandom: [true],
        questionOrderRandom: [true],
        NewQuestion: this.fb.array([this.addquestionGroup()]),

      }

    )
  }

  initialiseSetupQuiz() {
    this.quizBasicInfoForm = this.quizfb.group({
      activityName: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      region: [null, Validators.required],
      acronym: [null, Validators.required],
      userRoles: [null, Validators.required],
      selectallUsers: [false],
      partnerBegeoId: [[]],
      description: [null, Validators.required],
      tickets: ['', Validators.required],
      passPercentage: ['', [Validators.required, Validators.pattern(/^[0-9]$|^[1-9][0-9]$|^(100)$/)]],
      allowedAttempts: ['', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      // periodData:['',Validators.required],
      fiscalYear: ['', Validators.required],
      fiscalQuarter: ['', Validators.required],
      challengeRewards: [null, [Validators.required]],
      rewardsCap: [null, [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      proofofCompletion: [false],
      // numberOfPeople:['',Validators.required],
      // assignPeople:['',Validators.required],
      rewardType: ['POINTS', Validators.required],
      visibilityEndDate: [null],
      budgetSource: ['', Validators.required],
      budgetCapByRegionGroup: this.fb.array([]),
      manualDescription: ['']
    })
  }

  // setup quiz
  setupQuiz() {
    let dupsExist = false;
    if (this.quizBasicInfoForm.get('proofofCompletion')!.value) {
      dupsExist = this.checkDuplicateDocuments();
    }
    if (dupsExist) {
      this.showDupsError = true;
      return;
    }
    this.showDupsError = false;
    this.showQuizSetupForm = true;
  }
  // api to get the list of roles
  rolesList!: any;
  getRoles() {
    this.profileService.getAllRoles().subscribe((data: any) => {

      this.rolesList = data;
    })
  }
  // region list
  regionsList = ["USA", "CANADA", "LATAM", "APJ"];

  // Get the list of users under manager
  getUsersUnderManager() {
    this.managerService.getUsersUnderManager(this.userProfile.id).subscribe((data: any) => {
      if (data) {
        this.allUsers = data.reduce((users: any, item: any) => {
          if (users.find((obj: any) => obj.id === item.id) === undefined) {
            const user = {
              id: item.id,
              fullName: `${item.firstName} ${item.lastName} (${item.username})`
            };
            users.push(user);
          }
          return users;
        }, []);
      }
    }, err => {
      //this.errors = err;
    });
  };

  checkBegeoIdValid() {
    let begeoIds = this.quizBasicInfoForm.value.partnerBegeoId;
    let regex = /^\d+(?:,\d+)*$/;
    this.beGeoIdsValidationSuccess = regex.test(begeoIds);

  }

  selectedUsersForChallenge() {
    const userCount = this.quizBasicInfoForm.get('assignPeople')!.value;
    if (userCount) {
      return new Array(userCount.length);
    }
    return [];
  };

  onPartnerBegeoIdFileSelected(rows: any[]) {
    if (!rows || rows.length === 0) {
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const begeoIdList: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    this.quizBasicInfoForm.controls.partnerBegeoId.setValue(begeoIdList);
  }
  todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];

  done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];

  drop(event: CdkDragDrop<string[]>, index: number) {

    if (event.previousContainer === event.container) {
      (this.questionArray.controls[index] as any)['controls'].addNewOption.controls = event.container.data
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  ngOnInit() {
    //this.loadCiscoStyles('client-cisco.css');
    this.userProfile = LocalService.get('userProfile');
    this.intialiseQuizChallenge();
    this.initialiseSetupQuiz();
    this.getRoles();
    this.getUsersUnderManager();

    this.challengeList.find((x: any) => {
      if (x.shortName == 'quiz') {
        this.typeId = x.id;
        this.typeName = x.name;
      }
    })
    if (this.quizData != undefined) {
      this.getQuizChallengeData();
    }
    this.getCompanyCreditsAvailable();
    this.getFiscalOptions();
    this.selectedLanguage = localStorage.getItem('selectedLanguage') as string;
    this.getdocTypeList();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.isActiveEdit = this.quizData != undefined && this.quizData.status === 'ACTIVE' ? true : false;
    this.checkInactiveStatus();
  }
  backToBasicForm() {
    this.showQuizSetupForm = false;
  }
  loadCiscoStyles(styleName: any) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };

  ngOnDestroy(): void {
  };

  getSelectedRoleObjects(): any[] {
    const selectedIds = this.quizBasicInfoForm.get('userRoles') ? this.quizBasicInfoForm.get('userRoles')!.value : null;
    if (!selectedIds || !this.rolesList) { return []; }
    return this.rolesList.filter((role: any) => selectedIds.includes(role.id));
  }

  onRoleSelectionChange(selectedRoles: any[]): void {
    const rolesControl = this.quizBasicInfoForm.get('userRoles');
    if (rolesControl) {
      rolesControl.setValue(selectedRoles.map((role: any) => role.id));
    }
  }
  getBannerImage(event: any) {
    const file = event.target.files[0];
    if (!file) { return; }
    if (!file.type.startsWith('image/')) {
      this.popupMessageService.showError('Please select an image file (JPG, PNG, GIF)', 'error');
      return;
    }
    this.bannerImagName = '';
    this.selectedFileName = file.name;
    this.cropperEvent = event;
    this.imageCropperModalOpen = true;
  }

  onCropperConfirm(): void {
    if (this.cropperCroppedImage) {
      this.selectedFile = this.dataURLtoFile(this.cropperCroppedImage, this.selectedFileName);
      this.croppedPreviewSrc = this.cropperCroppedImage;
    }
    this.imageCropperModalOpen = false;
    this.cropperEvent = null;
    this.cropperCroppedImage = '';
  }

  closeCropperModal(): void {
    this.imageCropperModalOpen = false;
    this.cropperEvent = null;
    this.cropperCroppedImage = '';
    this.croppedPreviewSrc = '';
    this.selectedFileName = '';
    this.selectedFile = null;
    if (this.quizFileInput) {
      this.quizFileInput.nativeElement.value = '';
    }
  }

  onImageCropped(event: ImageCroppedEvent): void {
    this.cropperCroppedImage = event.base64;
  }

  onImageLoaded(event: any): void { }

  onCropperReady(event: any): void { }

  onLoadImageFailed(): void { }

  dataURLtoFile(dataURL: any, fileName: any) {
    const arr = dataURL.split(',')
    const mime = arr[0].split(':')[1].split(';')[0]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], fileName, { type: mime })
  }

  uploadImage() {
    const uploadData = new FormData();
    uploadData.append('file-to-be-uploaded', this.selectedFile);
    this.uploadInProgress = true;
    this.quizService.uploadQuizBanner(uploadData, this.selectedFileName).subscribe((data: any) => {
      this.uploadInProgress = false;
      if (data != '') {
        this.bannerImagName = data.message;
        this.uploadExsitingBanner = true;
      }
    }, () => {
      this.uploadInProgress = false;
      this.popupMessageService.showError('Banner upload failed. Please try again.', 'error');
    });
  }

  clearBannerSelection(): void {
    this.selectedFileName = '';
    this.selectedFile = null;
    this.croppedPreviewSrc = '';
    this.bannerImagName = '';
    this.uploadExsitingBanner = false;
    if (this.quizFileInput) {
      this.quizFileInput.nativeElement.value = '';
    }
  }

  previewCroppedImage(): void {
    this.bannerPreviewSrc = this.croppedPreviewSrc;
    this.bannerPreviewModalOpen = true;
  }

  //create challenge form submittion
  onSubmitCreateChallenge() {
    if (this.quizForm.get('bannerImg')!.value == '') {
      this.popupMessageService.showError('Please add the banner image', 'error');
      return;
    }
    let answerChoices: any = [];
    let questionDTOs: any = []
    let questionDTOsObj: any = {};
    let editquestionDto: any = {}
    let answerChoicesObj: any = {};
    this.questionArray.controls.forEach((val: any, i: number) => {

      questionDTOsObj = {};
      answerChoices = [];

      questionDTOsObj.correctAnswerExplanation = val['controls']['correctAnswerExplanation'].value;
      questionDTOsObj.question = val['controls']['question'].value;
      questionDTOsObj.type = val['controls']['answerType'].value;
      questionDTOsObj.sortOrder = i + 1;

      if (val['controls']['answerType'].value == 'TEXT') {
        questionDTOsObj.answerValidationRequired = val['controls']['answerValidation'].value;
      }


      if (this.quizData != undefined) {
        this.quizResponseData.quizDTO.questionDTOs.forEach((element: any, elmIndx: number) => {

          if (i == elmIndx) {

            questionDTOsObj.id = element.id;
          }
        });
      }
      questionDTOs.push(questionDTOsObj);

      val['controls'].addNewOption.controls.forEach((opt: any, opIndx: number) => {

        answerChoicesObj = {};
        answerChoicesObj.answer = opt.controls.possibleAnswer.value;
        answerChoicesObj.correct = opt.controls.correctAnser.value;
        answerChoicesObj.sortOrder = opIndx + 1;

        if (this.quizData != undefined) {
          this.quizResponseData.quizDTO.questionDTOs.forEach((qDtoVal: any, qIndx: number) => {
            qDtoVal.answerChoices.forEach((ansChoice: any, ansIndx: number) => {
              if (i == qIndx && opIndx == ansIndx) {

                answerChoicesObj.id = ansChoice.id;
              }
            })

          });
        }
        if (val['controls']['answerType'].value == 'TEXT') {
          answerChoicesObj = {};
        }
        answerChoices.push(answerChoicesObj);
        questionDTOsObj.answerChoices = answerChoices
      })

    })
    this.begeoIdsValues = typeof (this.quizBasicInfoForm.value.partnerBegeoId) === 'object' ? this.quizBasicInfoForm.value.partnerBegeoId : this.quizBasicInfoForm.value.partnerBegeoId.split(",");

    if (this.previewExistingBannerFlag && !this.uploadExsitingBanner) {
      this.bannerImagName = this.exsitingBannerImage;
    }
    let quizChallengeFormData = this.quizBasicInfoForm.value;
    let quizQuestionFormData = this.quizForm.value;
    data.name = quizChallengeFormData.activityName;
    data.startDate = new Date(quizChallengeFormData.startDate).toISOString();
    data.completeBy = new Date(quizChallengeFormData.endDate).toISOString();
    data.beGeoIds = this.begeoIdsValues;
    data.credits = quizChallengeFormData.rewardType === 'CREDITS' ? Number(quizChallengeFormData.tickets) : null;
    data.points = quizChallengeFormData.rewardType === 'POINTS' ? Number(quizChallengeFormData.tickets) : null;
    data.manualDescription = quizChallengeFormData.manualDescription ? quizChallengeFormData.manualDescription.replace(/&#160;/g, "") : quizChallengeFormData.manualDescription;
    data.description = quizChallengeFormData.description.replace(/&#160;/g, "");;
    data.acronym = quizChallengeFormData.acronym;
    data.id = this.quizData != undefined ? this.quizData.id : null;
    data.managerId = this.userProfile.id;
    data.regions = quizChallengeFormData.region;
    data.roleIds = quizChallengeFormData.userRoles;
    data.quizDTO.allowedAttempts = quizChallengeFormData.allowedAttempts;
    data.quizDTO.bannerImageName = this.bannerImagName;
    data.quizDTO.beGeoIds = this.begeoIdsValues;
    data.quizDTO.regions = quizChallengeFormData.region;
    data.quizDTO.roleIds = quizChallengeFormData.userRoles;
    data.quizDTO.exitMessage = quizQuestionFormData.exitMessage;
    data.quizDTO.welcomeMessage = quizQuestionFormData.welcomeMessage;
    data.quizDTO.failMessage = quizQuestionFormData.failMessage;
    data.quizDTO.passPercentage = quizChallengeFormData.passPercentage;
    data.quizDTO.questionDTOs = questionDTOs;
    data.quizDTO.credits = 0;
    data.status = this.quizData != undefined ? this.quizResponseData.status : "DRAFT";
    data.typeId = this.typeId;
    data.typeName = this.typeName;
    data.challengeIdentifier = this.quizData != undefined ? this.quizResponseData.challengeIdentifier : data.challengeIdentifier;
    data.category = "SPECIAL_ACTIVITY";
    data.userIds = null;
    data.winnersCount = quizChallengeFormData.rewardsCap;
    data.quizDTO.answerOptionsOrderRandom = quizQuestionFormData.answerOptionsOrderRandom;
    data.quizDTO.questionOrderRandom = quizQuestionFormData.questionOrderRandom;
    data.quizDTO.title = quizQuestionFormData.quizTitle;
    data.quizDTO.identifier = this.quizData != undefined ? this.quizResponseData.quizDTO.identifier : data.quizDTO.identifier;
    data.quizDTO.id = this.quizData != undefined ? this.quizResponseData.quizDTO.id : data.quizDTO.id;
    // data.fiscalYear=quizChallengeFormData.periodData.split('_')[0];
    // data.fiscalQuarter=quizChallengeFormData.periodData.split('_')[1];
    data.fiscalYear = quizChallengeFormData.fiscalYear;
    data.fiscalQuarters = quizChallengeFormData.fiscalQuarter;
    data.challengeRewards = quizChallengeFormData.challengeRewards.replace(/&#160;/g, "");
    data.creatorType = "CISCO_ADMIN";
    data.requiredUploadDocuments = quizChallengeFormData.proofofCompletion;
    if (quizChallengeFormData.proofofCompletion) {
      data.documents = quizChallengeFormData.proofOfCompletionGroup.map((x: any) => {
        return {
          id: x.id,
          name: x.proofName,
          requiredApproval: x.proofApproval
        }
      })
    } else {
      data.documents = [];
    };
    data.rewardType = quizChallengeFormData.rewardType;
    data.visibilityEndDate = quizChallengeFormData.visibilityEndDate;
    data.budgetSource = quizChallengeFormData.budgetSource;
    data.budgetCaps = this.getBudgetCapsData(quizChallengeFormData);
    if (this.quizData != undefined && this.quizData.id) {

      this.quizService.updateQuizChallenge(data).subscribe((res: any) => {

        if (res != '') {
          this.popupMessageService.showSuccess("Quiz Challenge updated successfully", 'success');
          data.quizDTO.id = '';
          this.resetQuizQuestionForm();
          this.submitStatusEvent.emit(true);
        }
      })
    } else {
      this.quizService.createQuizChallenge(data).subscribe((response: any) => {

        if (response != '') {
          this.popupMessageService.showSuccess("Quiz Challenge created successfully", 'success');
          this.resetQuizQuestionForm();
          this.submitStatusEvent.emit(true);
        }
      },
        (error: any) => {
          this.popupMessageService.showError('Something went wrong', 'error');
        }
      )
    }

  }
  // Reset form
  resetQuizQuestionForm() {
    this.quizForm.reset();
    this.quizBasicInfoForm.reset();
    this.intialiseQuizChallenge();
    this.bannerImagName = '';
    this.showQuizSetupForm = false;
    this.quizBasicInfoForm.patchValue({ 'rewardType': 'POINTS' })
    while (this.budgetCapByRegionGroupArray.value.length) {
      this.budgetCapByRegionGroupArray.removeAt(0);
    }
  }
  showDownloadExcelFormatDialog(): void {
    this.downloadExcelType = 'BEGEOID';
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    if (this.downloadExcelType === 'BEGEOID') {
      anchor.download = 'BEGEOID_LIST.xlsx';
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      anchor.download = 'END_CUSTOMER_LIST.xlsx';
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      anchor.download = 'PRODUCT_PAYOUTS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      anchor.download = 'PRODUCT_LIST.xlsx';
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      anchor.download = 'PRODUCT_LIST_ANY_PRODUCT.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      anchor.download = 'PRODUCT_SKUS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      anchor.download = 'PRODUCT_FAMILIES.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      anchor.download = 'TARGETS_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      anchor.download = 'TARGETS_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      anchor.download = 'PARTICIPANT_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      anchor.download = 'PARTICIPANT_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      anchor.download = 'Participation Challenge Completions Upload.xlsx';
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
  //on drag and drop of question 
  dropQuestion(event: CdkDragDrop<string[]>, index: number) {

    if (event.previousContainer === event.container) {
      // this.questionArray.controls[index]['controls'].addNewOption.controls=event.container.data
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      // $any(this.quizForm.get('NewQUestion')).value=
      //this.quizForm.get("NewQuestion") =event.container.data;
      this.quizForm.setControl('NewQuestion', this.fb.array(event.container.data))

    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  begeoIdModalOpen = false;
  begeoIdColumns = [{ field: 'begeoId', header: 'BeGeoId' }];

  get begeoIdRows(): any[] {
    const values = this.quizBasicInfoForm.controls.partnerBegeoId.value || [];
    return values.map((item: any, i: number) => ({ begeoId: (i + 1) + '. ' + item }));
  }

  partnerCompaniesClear(): void {
    this.quizBasicInfoForm.controls.partnerBegeoId.setValue([]);
  }

  openProductDialogContent(i: any) {
    this.begeoIdModalOpen = true;
  }

  closeBegeoIdModal() {
    this.begeoIdModalOpen = false;
  }
  // service call to get quiz challenge data
  quizResponseData!: any;
  getQuizChallengeData() {
    if (this.quizData != undefined && this.quizData.isClone) {
      this.setQuizChallengeData(this.quizData);
      this.quizResponseData = this.quizData;
    } else {
      this.quizService.getQuizChallengeData(this.quizData.id).subscribe((response: any) => {

        if (response) {
          this.setQuizChallengeData(response);
          this.quizResponseData = response;
        }
      })
    }
  }
  getTickets(response: any) {
    let noOfTickets = null;
    if (response && response.rewardType === 'CREDITS') {
      noOfTickets = response.credits;
    }
    if (response && response.rewardType === 'POINTS') {
      noOfTickets = response.points;
    }
    return noOfTickets;
  };
  // set quizchallenge data while edit
  setQuizChallengeData(val: any) {
    this.quizBasicInfoForm.patchValue({
      activityName: val.name,
      startDate: new Date(val.startDate),
      endDate: new Date(val.completeBy),
      region: val.regions,
      userRoles: val.roleIds,
      selectallUsers: [false],
      partnerBegeoId: val.quizDTO.beGeoIds.length > 0 ? val.quizDTO.beGeoIds : [],
      description: val.description,
      acronym: val.acronym,
      tickets: this.getTickets(val),
      passPercentage: val.quizDTO.passPercentage,
      allowedAttempts: val.quizDTO.allowedAttempts,
      periodData: val.fiscalYear + '_' + val.fiscalQuarter + '_' + new Date(val.startDate).toISOString() + '_' + new Date(val.completeBy).toISOString(),
      challengeRewards: val.challengeRewards,
      proofofCompletion: val.requiredUploadDocuments,
      fiscalYear: val.fiscalYear,
      fiscalQuarter: val.fiscalQuarters,
      rewardsCap: val.winnersCount > 0 ? val.winnersCount : null,
      rewardType: val.rewardType,
      visibilityEndDate: val.visibilityEndDate ? new Date(val.visibilityEndDate) : null,
      budgetSource: val.budgetSource,
      manualDescription: val.manualDescription
    })
    if (val.requiredUploadDocuments) {
      this.quizBasicInfoForm.addControl('proofOfCompletionGroup', this.fb.array(this.updateProofOfCompletionArray(val.documents)))
      val.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index))
    };
    this.quizBasicInfoForm.setControl('budgetCapByRegionGroup', this.fb.array(this.setBudgetCapData(val)))
    this.setQuestionQuizData(val)
    this.onRegionSelection(val)
  }

  // set question data while edit
  setQuestionQuizData(data: any) {
    this.quizForm.patchValue({
      welcomeMessage: data.quizDTO.welcomeMessage,
      exitMessage: data.quizDTO.exitMessage,
      failMessage: data.quizDTO.failMessage,
      bannerImg: data.quizDTO.bannerImageName,
      quizTitle: data.quizDTO.title,
      answerOptionsOrderRandom: data.quizDTO.answerOptionsOrderRandom,
      questionOrderRandom: data.quizDTO.questionOrderRandom,

    })
    this.bannerImagName = this.quizForm.get('bannerImg')!.value;
    this.exsitingBannerImage = this.quizForm.get('bannerImg')!.value;
    this.previewExistingBannerFlag = true;
    // this.quizForm.controls['NewQuestion'].patchValue()
    this.quizForm.setControl('NewQuestion', this.fb.array(this.setQuestionDTO(data.quizDTO.questionDTOs)));


  }
  setQuestionDTO(val: any) {
    let questionGroup: any[] = [];
    val.forEach((element: any, index: number) => {
      questionGroup.push(this.setquestionGroup(element, index))
    });
    // this.questionArray=questionGroup;




    return questionGroup;
  }
  setquestionGroup(data: any, index: number): FormGroup {
    //this.quizForm.setControl('addNewOption',);
    return this.fb.group({
      question: data.question,
      answerType: data.type,
      correctAnswerExplanation: data.correctAnswerExplanation,
      addNewOption: this.fb.array(this.setAnswerOptionsDto(data.answerChoices)),
      accordianState: index == 0 ? [false] : [false],
      addSingleQuestion: index == 0 ? [false] : [true],
      answerValidation: data.hasOwnProperty('answerValidationRequired') ? data.answerValidationRequired : ''
    })
  }
  setAnswerOptionsDto(val: any) {
    let answerGroup: any[] = [];
    val.forEach((element: any) => {
      answerGroup.push(this.setAnswerOptionGroup(element))
    })

    return answerGroup;
  }
  setAnswerOptionGroup(data: any) {
    return this.fb.group({
      possibleAnswer: data.answer,
      correctAnser: data.correct,
    })
  }
  onChangeRadioButton(i: number, idx: number) {

    (this.questionArray.controls[i] as any)['controls'].addNewOption.controls.forEach((element: any, elmtIndex: number) => {
      if (elmtIndex != idx) {
        (this.quizForm.controls.NewQuestion as any)['controls'][i].controls.addNewOption.controls[elmtIndex].controls.correctAnser.setValue(false)
      }


    });
  }
  // reset quizform
  resetquizForm() {
    this.quizBasicInfoForm.removeControl('proofOfCompletionGroup');
    if (this.quizData != undefined) {
      this.getQuizChallengeData()
    } else {
      this.quizForm.reset();
    }
    this.quizBasicInfoForm.patchValue({ 'rewardType': 'POINTS' })

  }
  //reset quizbasicform
  resetBasicquizForm() {
    this.quizBasicInfoForm.removeControl('proofOfCompletionGroup');
    if (this.quizData != undefined) {
      this.getQuizChallengeData()
    } else {
      this.quizBasicInfoForm.reset();
      this.intialiseQuizChallenge();
      this.bannerImagName = '';
      this.showQuizSetupForm = false;
    }
    this.quizBasicInfoForm.patchValue({ 'rewardType': 'POINTS' })

  }
  getCompanyCreditsAvailable() {
    this.managerService.getCompanyCreditsAvailable(this.userProfile.company.id).subscribe((data: any) => {
      this.totalCompanyCreditsAvailable = data.creditsRemaining;
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };
  onChangeChallengeName() {
    this.quizForm.patchValue({
      quizTitle: this.quizBasicInfoForm.get('activityName')!.value
    })
  }
  setIdentifier(data: any) {

    let acronym = "AC- QUIZ";

    // if (this.quizBasicInfoForm.value.periodData) { 
    //   let startDate=new Date(this.quizBasicInfoForm.value.periodData.split('_')[2])
    //   let endDate=new Date(this.quizBasicInfoForm.value.periodData.split('_')[3])

    //   this.quizBasicInfoForm.controls.startDate.setValue(formatDate(startDate,'yyyy-MM-dd','en'));
    //   this.quizBasicInfoForm.controls.endDate.setValue(formatDate(endDate,'yyyy-MM-dd','en'));

    // }
    if (this.quizBasicInfoForm.value.fiscalYear && this.quizBasicInfoForm.value.fiscalQuarter.length > 0) {
      let periodStartData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.quizBasicInfoForm.value.fiscalYear
        && x.fiscalQuarter == this.quizBasicInfoForm.value.fiscalQuarter[0])[0]
      let periodEndData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.quizBasicInfoForm.value.fiscalYear
        && x.fiscalQuarter == this.quizBasicInfoForm.value.fiscalQuarter[this.quizBasicInfoForm.value.fiscalQuarter.length - 1])[0]
      const sd = new Date(periodStartData.startDate);
      const ed = new Date(periodEndData.endDate);
      const startDate = new Date(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate());
      const endDate = new Date(ed.getUTCFullYear(), ed.getUTCMonth(), ed.getUTCDate());

      this.quizBasicInfoForm.controls.startDate.setValue(startDate);
      this.quizBasicInfoForm.controls.endDate.setValue(endDate);
    }
    let challengeName = '';
    if (this.quizBasicInfoForm.value.activityName) {
      this.quizBasicInfoForm.value.activityName.split(" ").filter((e: any) => e.trim()).forEach((x: any) => {
        challengeName += x.charAt(0).toUpperCase();
      });
    }
    let yearVal;
    // if (this.quizBasicInfoForm.value.periodData) {
    //   yearVal = this.quizBasicInfoForm.value.periodData.split('_')[0].slice(-2);
    // }
    if (this.quizBasicInfoForm.value.fiscalYear) {
      yearVal = this.quizBasicInfoForm.value.fiscalYear;
    }
    let quarterVal;
    // if (this.quizBasicInfoForm.value.periodData) {
    //   quarterVal = this.quizBasicInfoForm.value.periodData.split('_')[1].slice(-1);
    // }
    if (this.quizBasicInfoForm.value.fiscalQuarter) {
      quarterVal = this.quizBasicInfoForm.value.fiscalQuarter[this.quizBasicInfoForm.value.fiscalQuarter.length - 1];
    }
    if (challengeName) {
      acronym = acronym + '-' + challengeName
    }
    if (quarterVal) {
      acronym = acronym + '-' + quarterVal
    }
    if (yearVal) {
      acronym = acronym + yearVal
    }
    this.quizBasicInfoForm.controls.acronym.setValue(acronym);

  }
  getFiscalOptions() {
    this.managerService.getActivityFiscalOptions().subscribe((data: any) => {

      data.forEach((element: any) => {
        element.startDate = new Date(element.startDate).toISOString()
        element.endDate = new Date(element.endDate).toISOString()
      });
      this.fiscalOptionsList = data;
      this.fiscalYearList = Array.from(new Set(data.map((x: any) => x.fiscalYear)));
      this.fiscalQuarterList = Array.from(new Set(data.map((x: any) => x.fiscalQuarter)));
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };
  compare(val1: any, val2: any) {
    if (val1 && val2) {
      return val1.id === val2.id;
    }
  }

  getdocTypeList() {
    this.managerService.getDocTypeList().subscribe((data: any) => {
      this.docTypeList = data;
    }, (_err: any) => {
      //this.errors = err;
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  onProofofCompletionChange(event: any) {
    if (event.target.checked) {
      this.quizBasicInfoForm.addControl('proofOfCompletionGroup', this.fb.array([this.createproofOfCompletionArray()]))
      this.manageFilteredOptionsList(0)
    } else {
      this.quizBasicInfoForm.removeControl('proofOfCompletionGroup')
    }
  };

  createproofOfCompletionArray() {
    return this.fb.group({
      id: [null],
      proofName: ["", Validators.required],
      proofApproval: [false, Validators.required]
    })
  };

  updateProofOfCompletionArray(documentList: any) {
    let updatedArrayList: any[] = [];
    documentList.forEach((proofData: any) => {
      updatedArrayList.push(this.fb.group({
        id: [proofData.id],
        proofName: [proofData.name, Validators.required],
        proofApproval: [proofData.requiredApproval, Validators.required]
      }))
    });
    return updatedArrayList;
  };

  getProofOfCompletionGroup(form: any) {
    return form.controls.proofOfCompletionGroup ? form.controls.proofOfCompletionGroup.controls : null;
  };

  addProofOfCompletionGroup() {
    const control = <FormArray>this.quizBasicInfoForm.get('proofOfCompletionGroup')!;
    control.push(this.createproofOfCompletionArray());
    this.manageFilteredOptionsList(control.length - 1)
  };

  removeProofOfCompletionGroup(index: number) {
    const control = <FormArray>this.quizBasicInfoForm.get('proofOfCompletionGroup')!;
    control.removeAt(index);
    this.filteredOptions.splice(index, 1);
  };

  manageFilteredOptionsList(index: number) {
    const arrayControl = this.quizBasicInfoForm.get('proofOfCompletionGroup')! as FormArray;
    this.filteredOptions[index] = arrayControl.at(index).get('proofName')!.valueChanges.pipe(
      startWith<any>(''),
      map((value: any) => typeof value === 'string' ? value : value.name),
      map((name: any) => name ? this._filter(name) : this.docTypeList.slice())
    );
  };

  private _filter(name: any) {
    const filterValue = name.toLowerCase();
    return this.docTypeList.filter((option: any) => option.name.toLowerCase().indexOf(filterValue) === 0);
  };

  displayFn(option: any): string | undefined {
    return option ? (typeof (option) === 'string' ? option : option.name) : undefined;
  };

  checkDuplicateDocuments() {
    let dupsExist = false;
    const documentsList = this.quizBasicInfoForm.get('proofOfCompletionGroup')!.value.map((x: any) => x.proofName);
    if (new Set(documentsList).size !== documentsList.length) {
      dupsExist = true;
    }
    return dupsExist;
  };

  addBudgetCapPerRegionGroup(region: any) {
    return this.fb.group({
      region: [region],
      budgetCap: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [''],
      id: [''],
      modifiedBy: ['']
    })
  };

  updateBudgetCapPerRegionGroup(budget: any) {
    return this.fb.group({
      region: [budget.region],
      budgetCap: [budget.amount, [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [budget.createdBy],
      id: [budget.id],
      modifiedBy: ['']
    })
  };

  get budgetCapByRegionGroupArray(): FormArray {
    return <FormArray>this.quizBasicInfoForm.get('budgetCapByRegionGroup')!;
  };

  setBudgetCapData(res: any) {
    let budgetData: any[] = []
    if (res.rewardType === 'POINTS') {
      res.budgetCaps.forEach((budget: any) => {
        budgetData.push(this.updateBudgetCapPerRegionGroup(budget));
      })
    }
    return budgetData
  };

  getBudgetCapsData(formData: any) {
    let budgetCapData: any[] = [];
    if (formData.rewardType === 'POINTS') {
      budgetCapData = formData.budgetCapByRegionGroup.map((budgetRegion: any, index: number) => {
        return {
          activityBudgetCapType: "BUDGETCAP_REGIONAL",
          amount: budgetRegion.budgetCap,
          region: budgetRegion.region,
          id: budgetRegion.id || '',
          createdBy: budgetRegion.createdBy || this.userProfile.id,
          modifiedBy: this.quizResponseData ? this.userProfile.id : ''
        }
      })
    }
    return budgetCapData;
  };

  onRegionSelection(challengeData: any = null) {
    if (this.quizBasicInfoForm.controls.rewardType.value === 'POINTS') {
      const regionControl = this.quizBasicInfoForm.get('region');
      const selectedRegions: string[] = (regionControl ? regionControl.value : null) || [];
      this.regionsList.forEach((region: string) => {
        const index = this.budgetCapByRegionGroupArray.value.findIndex((budget: any) => budget.region === region);
        const isSelected = selectedRegions.includes(region);
        if (isSelected && index === -1) {
          this.budgetCapByRegionGroupArray.push(this.addBudgetCapPerRegionGroup(region));
        }
        if (!isSelected && index > -1) {
          this.budgetCapByRegionGroupArray.removeAt(index);
        }
      });
      this.quizBasicInfoForm.get('budgetSource')!.setValidators([Validators.required]);
      this.quizBasicInfoForm.get('budgetSource')!.updateValueAndValidity();
    } else {
      this.quizBasicInfoForm.get('budgetSource')!.setValue(null);
      this.quizBasicInfoForm.get('budgetSource')!.clearValidators();
      this.quizBasicInfoForm.get('budgetSource')!.updateValueAndValidity();
      while (this.budgetCapByRegionGroupArray.value.length) {
        this.budgetCapByRegionGroupArray.removeAt(0);
      }
    }

    if (this.quizBasicInfoForm.controls.rewardType.value === 'POINTS' || this.quizBasicInfoForm.controls.rewardType.value === 'CREDITS') {
      this.quizBasicInfoForm.get('tickets')!.setValue(this.getTickets(challengeData) || '');
      this.quizBasicInfoForm.get('tickets')!.setValidators([Validators.required]);
      this.quizBasicInfoForm.get('tickets')!.updateValueAndValidity();

      this.quizBasicInfoForm.get('manualDescription')!.setValue(null);
      this.quizBasicInfoForm.get('manualDescription')!.clearValidators();
      this.quizBasicInfoForm.get('manualDescription')!.updateValueAndValidity();
    } else {
      this.quizBasicInfoForm.get('tickets')!.setValue(null);
      this.quizBasicInfoForm.get('tickets')!.clearValidators();
      this.quizBasicInfoForm.get('tickets')!.updateValueAndValidity();

      this.quizBasicInfoForm.get('manualDescription')!.setValue(challengeData && challengeData.manualDescription || '');
      this.quizBasicInfoForm.get('manualDescription')!.setValidators([Validators.required]);
      this.quizBasicInfoForm.get('manualDescription')!.updateValueAndValidity();
    }
  };
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '350px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

  };
  rewardEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '97px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '354px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

  };
  onChangeAnswerformat(eve: any, i: number) {
    //this.quizBasicInfoForm.get('correctAnswerExplanation')!.setValue(null);
    if (eve.target.value == 'TEXT') {
      this.quizForm.controls.NewQuestion.value.forEach((ele: any, indx: number) => {
        (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('correctAnswerExplanation')!.setValue(''),
          (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('correctAnswerExplanation')!.clearValidators(),
          (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('correctAnswerExplanation')!.updateValueAndValidity(),


          this.quizForm.controls.NewQuestion.value[i].addNewOption.forEach((list: any, j: number) => {
            (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('possibleAnswer')!.setValue(''),
              (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('possibleAnswer')!.clearValidators(),
              (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('possibleAnswer')!.updateValueAndValidity(),
              (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('correctAnser')!.setValue(''),
              (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('correctAnser')!.clearValidators(),
              (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('addNewOption')['controls'][j].get('correctAnser')!.updateValueAndValidity()
          })



      })
    }
  }
  onSingleAnswerToggle(i: number, idx: number, value: boolean): void {
    (this.quizForm.controls.NewQuestion as any)['controls'][i].controls.addNewOption.controls[idx].controls.correctAnser.setValue(value);
    if (value) {
      this.onChangeRadioButton(i, idx);
    }
  }

  onAnswerTypeChange(item: any, i: number): void {
    (this.quizForm.get('NewQuestion')! as any)['controls'][i].get('answerType')!.setValue(item.id);
    this.onChangeAnswerformat({ target: { value: item.id } }, i);
  }

  checkInactiveStatus() {
    const q = new Date();
    const m = q.getMonth();
    const d = q.getDate();
    const y = q.getFullYear();

    const todayDate = new Date(y, m, d);

    const mydate = new Date(this.quizData ? this.quizData.completeBy : '');


    if ((todayDate > mydate) && this.quizData.status === 'INACTIVE') {
      this.readonlyFlag = true;
    } else {
      this.readonlyFlag = false;


    }

  }
  previewEsitingBanner() {
    this.bannerPreviewSrc = this.exsitingBannerImage;
    this.bannerPreviewModalOpen = true;
  }

  previewBannerImage() {
    this.bannerPreviewSrc = this.bannerImagName;
    this.bannerPreviewModalOpen = true;
  }

  closeBannerPreviewModal(): void {
    this.bannerPreviewModalOpen = false;
    this.bannerPreviewSrc = '';
  }
}
